export { default } from './HeadSEO';
